<template>
  <div class="w-100">
    <Loader class="w-100" :loading="loading">
      <div class=" p-list-representation-wrapper align-items-start">
        <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
          <div class="w-100" >
            <appHeader></appHeader>
          </div>

          <gameTab @changeTabGame="changeTabGame"></gameTab>

          <div class=" row p-list-representation-data w-100">
            <contentList
            :page="page"
            ></contentList>
          </div>

        </div>

      </div>

      <tableContent
      :page="page"
      :table-data="tableData"

      @paganationChangePage="paganationChangePage"
      ></tableContent>
    </Loader>

  </div>
</template>

<script>
import contentList from '../components/tabScorersAndKnockoutAndGroup/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/tabScorersAndKnockoutAndGroup/tableContent';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';
import gameTab from '../components/gameFuture/gameTab';


export default {
  name: "tabScorersAndKnockoutAndGroup",
  components: {
    contentList,
    appHeader,
    tableContent,
    gameTab,
  },

  props: {

  },

  data() {
    return {
      loading                                 : true,
      page                                    : 0,
      checkEmptyCity                     : 'default',
      formData      : {
        cup_id  : '',
        type    : '',
      },
      tableData                               : [],
      page                                    : 1,
      checkRunFirstGetDefaultProvinceAndCity  : 'initialLoaded',
      statusRunPaganation                     : true,
      checkPermissionMultiUpdateTableData       : true,



    }
  },

  watch: {

  },

  created() {
  },


  mounted() {
    // this.getEnum();
    const getParamsCupId                 = this.$route.params.cup_id;

    if (typeof(getParamsCupId) != 'undefined') {
      this.formData.cup_id = getParamsCupId;
    }


    this.updateTypeFilter();
    this.getTableData();
  },


  methods: {
    updateTypeFilter(){
      const checkStateActiveTab  = this.$route.params.state_active_tab;
      this.formData.type         = checkStateActiveTab;
    },

    updateTableDataAndProvinceAndCity(page){
      this.loading                                 = true;
      this.formData.page                           = page;
      this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';
      this.getTableData();
    },

    paganationChangePage(page){


      if (!this.checkPermissionMultiUpdateTableData) {
        // در صورتی که کاربر در صفحه دو تیبل باشد  و عدد صفحه تیبل تغییر کند //
        // دو در خواست اجرا می شود برای جلوگیری از دو در خواست همزمان //
        // کد زیر نوشته شد //
        if (page != 1) {
          this.checkPermissionMultiUpdateTableData = true;
        }
      }


      if (this.checkPermissionMultiUpdateTableData) {
        if (this.citySelected.id == -1) {
          this.formData.city_id = '';
        }

        this.page = page;
        this.updateTableDataAndProvinceAndCity(page);
      }
      else {
        // اجازه اجرا شدن لاجیک کال بک پجینیشن //
        this.checkPermissionMultiUpdateTableData = true;
      }

    },

    getTableData(){
      this.loading      = true;

      this.$store
      .dispatch('gameTab/tabScorersAndKnockoutAndGroup', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading      = false;
        this.tableData    = res.data;
      })
    },

    convertTimeStampInToJalali(tableData){
      tableData.map((t,i)=>{
        const resultConvert        = this.$moment.unix(t.being_hold_at).format("jYYYY/jMM/jDD HH:mm:ss").split(' ');

        t.StartGameDateJlali       = resultConvert[0];
        t.timeGameDateJlali        = resultConvert[1];
      })
    },

    changeTabGame(data){
      this.updateTypeFilter();
      if (data.stateActiveTab != 'passed' && data.stateActiveTab != 'future') {
        this.getTableData();
      }
    }






  }


}
</script>
